import { swRequest } from "@sourcewhale/core";

export const getFiles = ({ fileIds }, opts = {}) =>
  swRequest(
    {
      path: "/api/files/get",
      method: "GET",
      params: { fileIds },
    },
    opts,
  );

export const getDownloadUrl = (fileId) =>
  swRequest({
    path: "/api/files/get_download_url",
    method: "GET",
    params: { fileId },
  });

export const saveFile = (data, filename) =>
  swRequest({
    path: "/api/files/save",
    method: "POST",
    body: { data, filename },
  });
